import { Suspense, createContext, useEffect, useReducer } from "react";
import { initialState, modalReducer } from "@/context/Modal.reducer";
import { WishlistProvider } from "@/context/wishlist/Provider";
import { CheckoutProvider } from "@/context/checkout/provider";
import { AppProvider } from "@/context/global/provider";
import { CartProvider } from "@/context/cart/provider";
import { SessionProvider } from "next-auth/react";
import { appWithTranslation } from "next-i18next";
import { Cairo } from "next/font/google";
import { useRouter } from "next/router";

import Layout from "@/layout";
import dynamic from "next/dynamic";
import NextNProgress from "nextjs-progressbar";
import ErrorBoundary from "@/components/ErrorBoundary";
import SuspenseFallback from "@/components/SuspenseFallback";

const Modals = dynamic(() => import("@/components/modals"), {
  ssr: false,
});

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
// import "@/styles/custom/style-2.css";
// import "@/styles/custom/minify-style-2.css";
// // import "@/styles/custom/pdp-styling.css";
// // import "@/styles/custom/pdp-styling-2.css";
import "@/styles/custom/minify-pdp-styling-2.css";
// // import "@/styles/custom/style-1.css";
// import "@/styles/custom/minify-style-1.css";
// // import "@/styles/custom/style-m.css";
// import "@/styles/custom/minify-style-m.css";
import "@/styles/custom/minify-player.css";
// import "@/styles/custom/player.css";
import "@/styles/globals.css";
// import "@/styles/custom/styles-l.min.css";
// import "@/styles/custom/style.min.css";
// import "@/styles/custom/player.css";
// import "@/styles/custom/custom-bootstrap.css";

import { CompareProvider } from "@/context/compare/compare-context";
import CookieConsent from "@/components/CookieConsent";
import { AWSPersonalizeProvider } from "@/context/aws-personalize/aws-personalize-context";
import Script from "next/script";
import SlugsProvider from "@/context/categoryTree";

const cairoFont = Cairo({
  weight: ["200", "300", "400", "500", "600", "700", "800", "900"],
  style: ["normal"],
  display: "swap",
  subsets: ["arabic"],
  variable: "--font-cairo",
});

const Toaster = dynamic(
  () => import("react-hot-toast").then((c) => c.Toaster),
  { ssr: false }
);

export const ModalContext = createContext(null);

const App = ({ Component, pageProps }) => {
  const { locale } = useRouter();
  const [state, dispatch] = useReducer(modalReducer, initialState);
  // Pixel Ratio

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => console.log("scope is: ", registration.scope));
    }
  }, []);

  useEffect(() => {
    window.onresize = () => {
      const windowSize = window.devicePixelRatio;
      if (windowSize < 1) {
        document.body.style.width = windowSize * 100 + "%";
        document.body.style.margin = "auto";
      } else {
        document.body.style.width = "100%";
        document.body.style.margin = "auto";
      }
    };
  });
  // Direction
  useEffect(() => {
    document.body.style.direction = locale === "en" ? "ltr" : "rtl";
  }, [locale]);
  return (
    <>
      <Script src="/service-worker.js" async strategy="worker" />
      <Suspense fallback={<SuspenseFallback />}>
        <SessionProvider session={pageProps?.session}>
          <main className={`${cairoFont.variable} font-sans`} id="html-body">
            <NextNProgress
              color="#fff"
              startPosition={0.3}
              stopDelayMs={200}
              height={4}
              showOnShallow={false}
            />
            <ModalContext.Provider value={{ state, dispatch }}>
              <SlugsProvider>
                <AppProvider>
                  <CompareProvider>
                    <WishlistProvider>
                      <CheckoutProvider>
                        <CartProvider>
                          <AWSPersonalizeProvider>
                            <Layout>
                              <ErrorBoundary>
                                <Component {...pageProps} />
                              </ErrorBoundary>
                            </Layout>
                            <Modals />
                          </AWSPersonalizeProvider>
                        </CartProvider>
                      </CheckoutProvider>
                    </WishlistProvider>
                  </CompareProvider>
                </AppProvider>
              </SlugsProvider>
            </ModalContext.Provider>
            <Toaster position="bottom-center" reverseOrder={false} />
          </main>
          <CookieConsent className="hidden px-4 md:flex" />
        </SessionProvider>
      </Suspense>
    </>
  );
};

export default appWithTranslation(App);
